import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export enum KbaKey {
  MOTHER_NAME = 'MOTHER_NAME',
  BIRTHDAY = 'BIRTHDAY',
  FULLNAME = 'FULLNAME',
}

export default {
  async getByCpf(cpf: string) {
    return wrapEndpoint(() =>
      client.GET('/kba/by-cpf/{cpf}', {
        params: {
          path: {
            cpf,
          },
        },
      }),
    )
  },
  async create(cpf: string) {
    return wrapEndpoint(() =>
      client.POST('/kba', {
        body: {
          cpf,
        },
      }),
    )
  },
  async check(id: number, body: ApiSchemas['CheckKbaAnswerDto']) {
    return wrapEndpoint(() =>
      client.PATCH('/kba/{id}/check', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },
}
